import type { useTranslations } from 'next-intl';

type TranslateFn = ReturnType<typeof useTranslations>;

/**
 * Canonical name for commenters we could not resolve. Deliberately untranslated:
 * it doubles as the avatar hash key, so the color and initial stay stable across
 * locales while only the rendered text is localized.
 */
export const FALLBACK_DISPLAY_NAME = 'Guest';

const DISPLAY_NAME_KEY_MAP: Record<string, string> = {
  [FALLBACK_DISPLAY_NAME]: 'get-feedback-displayName-guest',
  Anonymous: 'get-feedback-displayName-anonymous',
};

/** The placeholder names the server sends for a commenter it couldn't name. */
const UNRESOLVED_NAMES = new Set([FALLBACK_DISPLAY_NAME, 'Anonymous']);

export function isUnresolvedName(name: string): boolean {
  return UNRESOLVED_NAMES.has(name);
}

/** Single source of truth for which name represents a commenter. */
export function resolveDisplayName(name?: string | null): string {
  return name?.trim() || FALLBACK_DISPLAY_NAME;
}

export function translateDisplayName(
  name: string | undefined | null,
  t: TranslateFn,
): string {
  const resolved = resolveDisplayName(name);
  const key = DISPLAY_NAME_KEY_MAP[resolved];
  return key ? t(key) : resolved;
}
